import React, { useEffect } from 'react';
import DesktopHeader from './header/DesktopHeader';
import MobileHeader from './header/MobileHeader';

const AuxHeader = ({ user }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://aux.tamu.edu/v1.9.0/icons/sprite.js';
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <DesktopHeader user={user} />
      <MobileHeader user={user} />
    </>
  );
};

export default AuxHeader;
